import {RookieDistrictFullData} from "../../../app/interfaces/rookie/rookie-district-full-data";
import {Image} from "../../../app/interfaces/image";
import {RookieDistrictState} from "../../../app/enums/rookie/rookie-district-state";

const placeHolderDir = "/assets/img/placeholders/";
const imageFileName = "BER_final_Placeholder_Arrow_01.svg";

const bentoCurrentYear: number = new Date().getFullYear();

const placeholderImage: Image = {
  huge: {url: placeHolderDir + imageFileName, width: 1000},
  info: {caption: "Bild nicht gefunden", copyright: "Berufsreise.at", alttext: "Bild nicht gefunden"},
  landscape: {url: placeHolderDir + imageFileName, width: 100},
  large: {url: placeHolderDir + imageFileName, width: 700},
  medium: {url: placeHolderDir + imageFileName, width: 500},
  portrait: {url: placeHolderDir + imageFileName, width: 400},
  xlarge: {url: placeHolderDir + imageFileName, width: 1500}
};

export default {
  id: 2,
  name: "Lienz",
  eventType: 2,
  state: RookieDistrictState.NOTSET,
  mainEventFromToString: "20.07.2027 – 01.01.2028",
  scholar: {
    register_success: {
      title: "Vielen Dank für deine Anmeldung!",
      text: "Die Daten wurden erfolgreich abgesendet und du erhältst in wenigen Minuten eine Bestätigung per E-Mail. " +
        "Bitte überprüfe auch deinen SPAM-Ordner. Solltest du in 24 Stunden keine Bestätigung erhalten haben, bitten " +
        "wir dich, Kontakt mit uns aufzunehmen.",
      questions: "Bei Fragen steht dir gerne die Wirtschaftskammer Lienz unter " +
        "E&nbsp;<a href=\"mailto:lienz@wktirol.at\">lienz@wktirol.at</a> und " +
        "T&nbsp;<a href=\"tel:05909053510\">05 90 90 5-3510</a> zur Verfügung."
    },
    register_errors: {
      ALREADY_REGISTERED: {
        title: "Du bist bereits angemeldet!",
        text: "Mit deinen Daten wurde für mindestens einen der gewählten Termine bereits ein Schnupperplatz " +
          "registriert. Pro Termin ist nur eine Anmeldung möglich, da sich die Schnupperplätze sonst überschneiden. " +
          "Mehr Informationen über den Ablauf findest du auf der Startseite."
      }
    }
  },
  providerRegisterTime: {
    closeAt: "",
    openAt: "",
  },
  companySignup: {
    head_title: "Ermöglichen Sie<br/> <em>jungen Talenten</em> <br/>Einblicke in Ihr<br/> Unternehmen",
    head_text: "Mit einer Teilnahme an Rookie geben Sie Schüler:innen ab der 8. Schulstufe die Möglichkeit, " +
      "einzigartige Einblicke in Ihr Unternehmen zu erhalten. Sie lernen motivierte, junge Talente kennen und können " +
      "Ihr Unternehmen und Ausbildungsangebot direkt erlebbar machen.",
    contact: "Die Anmeldung für Rookie Lienz ist aktuell geschlossen. Bei Fragen steht Ihnen gerne die " +
      "Wirtschaftskammer Lienz unter E&nbsp;<a href=\"mailto:lienz@wktirol.at\">lienz@wktirol.at</a> und " +
      "T&nbsp;<a href=\"tel:05909053510\">05 90 90 5-3510</a> zur Verfügung.",
  },
  timeSlots: [],
  districtSelector: {
    iconSrc: "/assets/img/rookie/district-selector/lienz-bezirk.svg",
    description: "Finde deinen Schnupperplatz in Lienz."
  },
  home: {
    hero: {
      title: "Finde deinen Schnupperplatz in <em>Lienz</em>",
      icons: [
        "/assets/img/icons/rookie/PATCH-1-Lienz.svg",
        "/assets/img/icons/rookie/PATCH-2-Lienz.svg",
        "/assets/img/icons/rookie/PATCH-3-Lienz.svg",
        "/assets/img/icons/rookie/PATCH-4-Lienz.svg"
      ],
      text: "Bald ist es wieder soweit und Rookie - Schüler:innen in Betrieben geht in die nächste Runde. Über den " +
        "Anmeldestart wirst du rechtzeitig von deiner Lehrperson sowie online über diese Seite informiert."
    },
    functions: {
      title: "So funktioniert <em>Rookie Tirol</em>",
      cards: [
        {
          index: 1,
          title: 'Deine Schnupperplätze finden',
          hint: "",
          iconSrc: '/assets/img/icons/UA-Betriebserkundungen.svg',
          text: 'Finde deine persönlichen Favoriten für deine Schnuppertage. Du hast die Möglichkeit, dich für einen ' +
            'oder mehrere Schnuppertage in einem Unternehmen anzumelden. Tipp: Noch schneller gelangst du wieder ' +
            'zum Angebot mit dem individuellen Code.',
          checklistTitle: 'Checkliste für Schüler:innen:',
          checklistItems: [
            'Schnupperangebot erforschen',
            'Schnupperplatz finden',
            'Individuellen Code merken'
          ]
        },
        {
          index: 2,
          title: 'Für Schnupperplatz anmelden',
          hint: "Anmeldung ausschließlich über diese Website",
          iconSrc: '/assets/img/icons/Berufsfelder-Medien-Kultur.svg',
          text: 'Je früher du buchst, desto mehr Auswahl an Schnuppertagen steht dir zur Verfügung. Eine ' +
            'erfolgreiche Anmeldung wird dir am Bildschirm sowie mit einer E-Mail bestätigt. In dieser werden ' +
            'nochmal alle Informationen zum Angebot sowie Kontaktinformationen zum Unternehmen zusammengefasst.',
          checklistTitle: 'Checkliste für Schüler:innen:',
          checklistItems: [
            'Rechtzeitig buchen',
            'Wähle deine Schnupperplätze aus',
            'Schicke das Anmeldeformular für jeden Betrieb ab',
            'Bei erfolgreicher Anmeldung: Bestätigungsmail erhalten',
            'Bei ausgebuchtem Angebot: Alternative suchen und buchen'
          ]
        },
        {
          index: 3,
          title: 'Telefonische Kontaktaufnahme',
          hint: "",
          iconSrc: '/assets/img/icons/BO-Vortrag.svg',
          text: 'Nach erfolgreicher Anmeldung erhältst du eine E-Mail mit allen wichtigen Informationen. Melde ' +
            'dich bei deiner Kontaktperson, stelle dich kurz vor und kläre Rahmenbedingungen wie Dauer oder ' +
            'Bekleidungsvorschriften. Als Leitfaden erhältst du in der Schule einen Fragebogen.',
          checklistTitle: 'Wichtige Fragen klären:',
          checklistItems: [
            'Wann beginnt die Arbeit?',
            'Wo ist der Treffpunkt?',
            'Welche Kleidung soll ich tragen?',
            'Gibt es etwas Besonderes zu beachten?'
          ]
        },
        {
          index: 4,
          title: 'Schnuppertag absolvieren',
          hint: "",
          iconSrc: '/assets/img/icons/UA-Berufspraktische-Tage.svg',
          text: 'An deinen Schnuppertagen bekommst du einmalige Einblicke in Berufe im ausgewählten Unternehmen. ' +
            'Nutze die Gelegenheit, erste berufliche Erfahrungen zu sammeln, Fragen zu stellen und finde heraus, ' +
            'ob der Beruf zu dir passt.',
          checklistTitle: 'Checkliste für Schüler:innen:',
          checklistItems: [
            'Erscheine pünktlich',
            'Trage passende Kleidung',
            'Arbeite aufmerksam mit und stelle Fragen',
            'Beachte Sicherheitsanweisungen und Vorgaben'
          ]
        },
        {
          index: 5,
          title: 'Feedback abgeben',
          hint: "",
          iconSrc: '/assets/img/icons/Berufsfelder-Medien-Kultur.svg',
          text: 'Nach den Schnuppertagen erhältst du einen Feedbackbogen. Hat dir etwas besonders gut gefallen, ' +
            'wurden deine Erwartungen erfüllt, wurdest du in deiner Berufswahl bestärkt? Hier kannst du dein ' +
            'Feedback festhalten.',
          checklistTitle: 'Checkliste für Schüler:innen:',
          checklistItems: [
            'Erhalte den Feedbackbogen von deiner Lehrperson',
            'Gib Rückmeldung zu deinen Erfahrungen',
            'Was hat dir gefallen?',
            'Verbesserungsvorschläge'
          ]
        }
      ]
    },
    bentoItems: [
      {
        type: "simple",
        width: "2",
        images: [
          {
            image: "/assets/img/rookie/start-bento/01.svg",
            imagePosition: "center"
          }
        ],
        cardTexts: [
          {text: "max. 5 Tage", textPosition: "center"},
          {text: "in Betrieben schnuppern", textPosition: "bottom"}
        ],
        backgroundColor: "red"
      },
      {
        type: "slider",
        width: "3",
        backgroundColor: "blue",
        slides: [
          {
            title: "Praxisnah in Unternehmen hineinschnuppern",
            image: "/assets/img/rookie/start-bento/02-1.svg",
            color: "blue"
          },
          {
            title: "Berufe hautnah erleben",
            image: "/assets/img/rookie/start-bento/02-02.svg",
            color: "rock"
          },
          {
            title: "Unternehmen aus deinem Bezirk",
            image: "/assets/img/rookie/start-bento/02-03.svg",
            color: "yellow"
          }
        ]
      },
      {
        type: "video",
        width: "5",
        videoUrl: "/assets/img/rookie/start-bento/bento.mp4",
        videoThumbnail: "/assets/img/games/previews/guess-image.png"
      },
      {
        type: "animation",
        width: "4",
        animationFile: "/assets/img/rookie/start-bento/jahreszahlen/04-" + bentoCurrentYear + ".svg",
        backgroundColor: "light-blue"
      },
      {
        type: "slider",
        width: "3",
        backgroundColor: "green",
        slides: [
          {
            title: "Unternehmen präsentieren",
            image: "/assets/img/rookie/start-bento/05-1.svg",
            color: "green"
          },
          {
            title: "Zukünftige Lehrlinge kennen lernen",
            image: "/assets/img/rookie/start-bento/05-01.svg",
            color: "light-blue"
          },
          {
            title: "Begeisterung wecken",
            image: "/assets/img/rookie/start-bento/05-02.svg",
            color: "river"
          }
        ]
      },
      {
        type: "simple",
        width: "3",
        backgroundColor: "river",
        backgroundImage: "/assets/img/rookie/start-bento/06.svg",
        cardTexts: [
          {
            text: "Präsentiere dein Unternehmen und finde motivierte Talente",
            textPosition: "center"
          }
        ]
      }
    ],
    dates: {
      title: "Wichtige <em>Termine</em>",
      text: "Ab wann ist eine Anmeldung möglich und in welchem Zeitraum finden die Schnuppertage statt? Hier " +
        "findest du alles, was du dazu wissen musst",
      cards: [{
        iconSrc: "/assets/img/icons/UA-Vorstellung.svg",
        title: "Anmeldestart",
        rows: [],
        labelText: "Vormerken und nicht verpassen!",
        labelIcon: "requirement--Risikobewusstsein--278"
      },
        {
          iconSrc: "/assets/img/icons/Auslandspraktika.svg",
          title: "Schnuppertage",
          rows: [],
          labelText: "6 Grossartige Tage",
          labelIcon: "star"
        }]
    },
    testimonials: {
      title: "Was sagen <em>andere?</em>",
      text: "Höre direkt von Schüler:innen und Unternehmen, die bereits an Rookie teilgenommen haben.",
      visible: true,
      cards: [
        {
          text: "Die Rookie Days sind für viele Jugendliche der erste Schritt auf dem Weg zu einer Lehre. Sie geben " +
            "ihnen Orientierung bei einer wichtigen Zukunftsentscheidung und ermöglichen es gleichzeitig den " +
            "Osttiroler Betrieben, junge Menschen frühzeitig für ihre Ausbildungsangebote und beruflichen " +
            "Perspektiven zu begeistern.",
          name: "Doris Lang",
          position: "Theurl Austrian Premium Timber",
          avatar: {
            huge: {url: "/assets/img/rookie/testimonials/Theurl_Personen.png", width: 1000},
            info: {caption: "Unternehmen Logo", copyright: "Berufsreise.at", alttext: "Unternehmen Logo"},
            landscape: {url: "/assets/img/rookie/testimonials/Theurl_Personen.png", width: 100},
            large: {url: "/assets/img/rookie/testimonials/Theurl_Personen.png", width: 700},
            medium: {url: "/assets/img/rookie/testimonials/Theurl_Personen.png", width: 500},
            portrait: {url: "/assets/img/rookie/testimonials/Theurl_Personen.png", width: 400},
            xlarge: {url: "/assets/img/rookie/testimonials/Theurl_Personen.png", width: 1500}
          },
          logo: {
            huge: {url: "/assets/img/rookie/testimonials/Logo_Theurl.png", width: 1000},
            info: {caption: "Unternehmen Logo", copyright: "Berufsreise.at", alttext: "Unternehmen Logo"},
            landscape: {url: "/assets/img/rookie/testimonials/Logo_Theurl.png", width: 100},
            large: {url: "/assets/img/rookie/testimonials/Logo_Theurl.png", width: 700},
            medium: {url: "/assets/img/rookie/testimonials/Logo_Theurl.png", width: 500},
            portrait: {url: "/assets/img/rookie/testimonials/Logo_Theurl.png", width: 400},
            xlarge: {url: "/assets/img/rookie/testimonials/Logo_Theurl.png", width: 1500}
          }
        },
        {
          text: "Die Rookie-Workshops sind eine echte Erfolgsgeschichte in Osttirol. Seit Jahren leisten sie einen " +
            "unverzichtbaren Beitrag dazu, die Lehre in unserem Bezirk nachhaltig zu stärken. Das Konzept ist genial " +
            "wie einfach: Schüler:innen der 4. Klassen Mittelschule buchen ihre Schnuppertage digital und direkt bei " +
            "unseren engagierten Betrieben und erleben Handwerk, Technik und Dienstleistung hautnah.\n" +
            "Ich lade alle Schüler:innen und Betriebe herzlich ein: Seid dabei, nutzt diese Chance und gestaltet die " +
            "berufliche Zukunft unserer Region aktiv mit!",
          name: "Johann Kollreider",
          position: "Wirtschaftskammer Lienz",
          avatar: {
            huge: {url: "/assets/img/rookie/testimonials/Johann_Kollreider.png", width: 1000},
            info: {caption: "Unternehmen Logo", copyright: "Berufsreise.at", alttext: "Unternehmen Logo"},
            landscape: {url: "/assets/img/rookie/testimonials/Johann_Kollreider.png", width: 100},
            large: {url: "/assets/img/rookie/testimonials/Johann_Kollreider.png", width: 700},
            medium: {url: "/assets/img/rookie/testimonials/Johann_Kollreider.png", width: 500},
            portrait: {url: "/assets/img/rookie/testimonials/Johann_Kollreider.png", width: 400},
            xlarge: {url: "/assets/img/rookie/testimonials/Johann_Kollreider.png", width: 1500}
          },
          logo: {
            huge: {url: "/assets/img/rookie/testimonials/Logo_WK.png", width: 1000},
            info: {caption: "Unternehmen Logo", copyright: "Berufsreise.at", alttext: "Unternehmen Logo"},
            landscape: {url: "/assets/img/rookie/testimonials/Logo_WK.png", width: 100},
            large: {url: "/assets/img/rookie/testimonials/Logo_WK.png", width: 700},
            medium: {url: "/assets/img/rookie/testimonials/Logo_WK.png", width: 500},
            portrait: {url: "/assets/img/rookie/testimonials/Logo_WK.png", width: 400},
            xlarge: {url: "/assets/img/rookie/testimonials/Logo_WK.png", width: 1500}
          }
        }
      ]
    },
    startFotos: {
      media: [
        {
          image: "/assets/img/rookie/start-fotos/bereit-links.png",
          video: "/assets/img/rookie/start-fotos/bereit-links.mp4"
        },
        {
          image: "/assets/img/rookie/start-fotos/bereit-mitte.png",
          video: "/assets/img/rookie/start-fotos/bereit-mitte.mp4"
        },
        {
          image: "/assets/img/rookie/start-fotos/bereit-rechts.png",
          video: "/assets/img/rookie/start-fotos/bereit-rechts.mp4"
        }
      ]
    },
    faq: {
      categories: [
        {
          title: "Für Schüler:innen",
          items: [
            {
              question: "Was ist Rookie?",
              answer: "Rookie Lienz ermöglicht es dir, erste berufliche Erfahrungen in einem Beruf zu sammeln " +
                "und Unternehmen aus der Region kennenzulernen. Rookie bietet dir eine Übersicht an Unternehmen " +
                "aus dem Bezirk Lienz, welche im vorgegebenen Zeitraum Workshops anbieten. Du kannst dabei – falls " +
                "du eine Schule besuchst in Absprache mit deiner Lehrperson - einen oder mehrere Tage in einem " +
                "Unternehmen buchen."
            },
            {
              question: "Wie kann ich mich für Rookie Schnuppertage anmelden?",
              answer: "Wir bitten dich, deine Anmeldung ausschließlich über " +
                "<a href=\"https://www.berufsreise.at/rookie/lienz\">www.berufsreise.at/rookie/lienz</a> vorzunehmen. " +
                "Eine Anmeldung direkt über das Unternehmen ist aus organisatorischen Gründen nicht möglich."
            },
            {
              question: "Wann kann ich mich für den gewünschten Schnuppertag anmelden?",
              answer: "Die Anmeldung beginnt jedes Jahr am 1. September."
            },
            {
              question: "Was ist bei der Anmeldung zu beachten?",
              answer: "Jedes Unternehmen kann einen oder mehrere Workshoptage pro Lehrberuf an ihren Standorten " +
                "anbieten. Hast du einen interessanten Workshop gefunden, kannst du diesen direkt über die " +
                "Anmeldemaske buchen. Abhängig von der Verfügbarkeit, kannst du einen oder mehrere Termine auswählen. " +
                "Die Anzahl der verfügbaren Workshops ist begrenzt. Es gilt das first come – first service Prinzip. " +
                "Ob deine Anmeldung erfolgreich war, wird dir nach dem Absenden des Formulars angezeigt und du " +
                "erhältst eine Bestätigungs-E-Mail."
            },
            {
              question: "Was hat es mit dem Code bei den Schnupperplätzen auf sich?",
              answer: "Jedes Angebot hat einen individuellen Code. Damit du am Anmeldetag schnell zum gewünschten " +
                "Schnupperplatz findest, kannst du den Code in der Menüleiste unter „Zum Schnupperplatz mit Code“ " +
                "eingeben."
            }
          ]
        },
        {
          title: "Für Unternehmen",
          items: [
            {
              question: "Worum handelt es sich bei Rookie?",
              answer: "Rookie ist ein Projekt der Bezirksstelle Lienz der Wirtschaftskammer Tirol welches " +
                "Schüler:innen eine Übersicht und direkte Buchungsmöglichkeit für Schnuppertage im Bezirk bietet. " +
                "In einem vorgegebenen Zeitraum von zirka einem Monat können Sie alle zur Verfügung stehende Termine " +
                "einmelden. Diese Termine sind jeweils bis spätestens zwei Werktage vor dem tatsächlichen " +
                "Workshoptag(en) für die Schüler:innen buchbar. Je nach Verfügbarkeit können die Schüler:innen einen " +
                "oder mehrere Schnuppertage bei Ihnen buchen."
            },
            {
              question: "Wie kann ich als Unternehmen an Rookie teilnehmen?",
              answer: "Unternehmen aus dem Bezirk Lienz haben die Möglichkeit teilzunehmen. Das Anmeldeformular " +
                "wird im Frühsommer durch die Bezirksstelle Lienz der Wirtschaftskammer Tirol ausgesendet."
            },
            {
              question: "An wen kann ich mich bei Fragen wenden?",
              answer: "Bei Fragen steht Ihnen gerne die Wirtschaftskammer Lienz unter " +
                "E&nbsp;<a href=\"mailto:lienz@wktirol.at\">lienz@wktirol.at</a> und " +
                "T&nbsp;<a href=\"tel:05909053510\">05 90 90 5-3510</a> zur Verfügung."
            },
            {
              question: "Welche Schulstufe nimmt an Rookie teil?",
              answer: "Schüler:innen ab der 8. Schulstufe sowie außerschulische Jugendliche aus dem Bezirk Lienz " +
                "nehmen an den Rookie Workshops teil."
            },
            {
              question: "Was kostet die Teilnahme?",
              answer: "Die Teilnahme ist kostenlos. "},
            {
              question: "Wie viele Schnupperplätze kann ich anbieten?",
              answer: "Pro Lehrberuf und Standort können Sie maximal 10 Jugendlichen einen Workshopplatz anbieten."
            },
            {
              question: "Wie werde ich über Buchungen in Kenntnis gesetzt?",
              answer: "Sobald eine Buchung erfolgreich durchgeführt wurde, erhalten Sie eine E-Mail mit allen " +
                "wichtigen Informationen. Diese E-Mail wird ebenfalls an den Schüler/die Schülerin sowie die Schule " +
                "und die Bezirksstelle gesendet."
            },
            {
              question: "Wie lange dauert ein Schnuppertag?",
              answer: "Die Schnuppertage dürfen nur zu typischen Unterrichtszeiten (Mo-Fr 8:00 bis 18:00 Uhr) und " +
                "nicht länger als 8 Stunden täglich im Betrieb sein."
            },
            {
              question: "Wie sind die Jugendlichen versichert?",
              answer: "Es handelt sich hierbei um eine schulbezogene Veranstaltung, die Schüler:innen sind somit " +
                "über die Schule versichert. Außerschulische Jugendliche werden über das Jugendcoaching für die " +
                "Schnuppertage versichert."
            },
            {
              question: "Welche rechtlichen Rahmenbedingungen sind zu beachten?",
              answer: "Wichtige Informationen zum Thema Rechte und Pflichten bei Schnuppertagen finden Sie " +
                "beispielsweise auf den Seiten der " +
                "<a href=\"https://www.wko.at/tirol/bildung-lehre/die-schnupperlehre\" target='_blank'>WKO</a>, " +
                "von der <a href=\"https://tirol.arbeiterkammer.at/schnuppern\" target='_blank'>AK</a> und der " +
                "<a href=\"https://www.gesundheitskasse.at/cdscontent/?contentid=10007.904908&portal=oegkdgportal\" target='_blank'>ÖGK</a>."
            },
          ]
        }
      ]
    }
  }
} as RookieDistrictFullData;
